import Paragraph, { HeadingParagraph } from './Paragraph';

import { CtfRichTextTag } from '@/utils/constants';

export default function Content({
  nodeType,
  contents,
  isBlockquote,
  isBlockquoteBodyLarge,
  invert,
  isDiv,
  style,
  entries,
}) {
  let render = null;
  switch (nodeType) {
    case CtfRichTextTag.BLOCKQUOTE:
      render = (
        <Paragraph
          entries={entries}
          contents={contents?.[0]?.content}
          nodeType={contents?.[0]?.nodeType}
          invert={invert}
          isBlockquote
          isBlockquoteBodyLarge={isBlockquoteBodyLarge}
          style={style}
        />
      );
      break;
    case CtfRichTextTag.PARAGRAPH:
      render = (
        <Paragraph
          entries={entries}
          contents={contents}
          isBlockquote={isBlockquote}
          isBlockquoteBodyLarge={isBlockquoteBodyLarge}
          isDiv={isDiv}
          invert={invert}
          style={style}
        />
      );
      break;

    case CtfRichTextTag.HEADING_1:
      render = (
        <HeadingParagraph contents={contents} textTag="h1" entries={entries} />
      );
      break;

    case CtfRichTextTag.HEADING_2:
      render = (
        <HeadingParagraph contents={contents} textTag="h2" entries={entries} />
      );
      break;

    case CtfRichTextTag.HEADING_3:
      render = (
        <HeadingParagraph contents={contents} textTag="h3" entries={entries} />
      );
      break;

    case CtfRichTextTag.HEADING_4:
      render = (
        <HeadingParagraph contents={contents} textTag="h4" entries={entries} />
      );
      break;

    case CtfRichTextTag.HEADING_5:
      render = (
        <HeadingParagraph contents={contents} textTag="h5" entries={entries} />
      );
      break;

    case CtfRichTextTag.HEADING_6:
      render = (
        <HeadingParagraph contents={contents} textTag="h6" entries={entries} />
      );
      break;

    case CtfRichTextTag.HR:
      break;

    default:
      render = <p>{nodeType}</p>;
  }
  return render;
}
